import { createFileRoute } from "@tanstack/react-router";

import { MASTODON_LIMIT_FAQS } from "@/components/marketing/mastodon-limit-faqs";
import { MastodonLimitsTool } from "@/components/marketing/mastodon-limits-tool";
import { toolPageHead } from "@/lib/seo";

/**
 * `head` is never code-split, so it must not reach into the component module —
 * that would drag the whole tool into the shared entry chunk. The FAQs live in
 * their own module for exactly this reason; see `mastodon-limit-faqs.ts`.
 */
export const Route = createFileRoute("/(public)/tools/mastodon-limits")({
  head: () => toolPageHead("mastodonLimits", MASTODON_LIMIT_FAQS),
  component: MastodonLimitsTool,
});
